/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyChangeNameRequestDto
 */
export interface CompanyChangeNameRequestDto {
  /**
   *
   * @type {string}
   * @memberof CompanyChangeNameRequestDto
   */
  value: string;
}

export function CompanyChangeNameRequestDtoFromJSON(json: any): CompanyChangeNameRequestDto {
  return CompanyChangeNameRequestDtoFromJSONTyped(json, false);
}

export function CompanyChangeNameRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyChangeNameRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    value: json["value"],
  };
}

export function CompanyChangeNameRequestDtoToJSON(value?: CompanyChangeNameRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    value: value.value,
  };
}
